// Cómo se conecta un agente o una aplicación: la misma llave sirve para los modelos (forma de OpenAI) y para el MCP.
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { Copiable } from './Comunes';

export function ComoConectar({ llave = 'gw_…', modelo = 'rapido' }: { llave?: string; modelo?: string }) {
  const config = useQuery({ queryKey: ['config'], queryFn: () => api<{ openai: string; mcp: string }>('/api/config'), staleTime: Infinity });
  const [pestana, setPestana] = useState<'python' | 'js' | 'curl' | 'mcp'>('python');
  if (!config.data) return null;
  const { openai, mcp } = config.data;
  const ejemplos = {
    python: `from openai import OpenAI\n\ncliente = OpenAI(base_url="${openai}", api_key="${llave}")\nr = cliente.chat.completions.create(\n    model="${modelo}",\n    messages=[{"role": "user", "content": "¿Cuánto vendimos ayer?"}],\n)\nprint(r.choices[0].message.content)`,
    js: `import OpenAI from 'openai';\n\nconst cliente = new OpenAI({ baseURL: '${openai}', apiKey: '${llave}' });\nconst r = await cliente.chat.completions.create({\n  model: '${modelo}',\n  messages: [{ role: 'user', content: '¿Cuánto vendimos ayer?' }],\n});\nconsole.log(r.choices[0].message.content);`,
    curl: `curl ${openai}/chat/completions \\\n  -H "Authorization: Bearer ${llave}" \\\n  -H "Content-Type: application/json" \\\n  -d '{"model": "${modelo}", "messages": [{"role": "user", "content": "Hola"}]}'`,
    mcp: JSON.stringify({ mcpServers: { 'glubi-gateway': { type: 'http', url: mcp, headers: { Authorization: `Bearer ${llave}` } } } }, null, 2),
  };
  return (
    <div>
      <div className="tabs" style={{ margin: '4px 0 12px' }}>
        {([['python', 'Python'], ['js', 'JavaScript'], ['curl', 'curl'], ['mcp', 'Cliente MCP']] as const).map(([k, t]) => (
          <button key={k} className={`tab ${pestana === k ? 'active' : ''}`} onClick={() => setPestana(k)}>{t}</button>
        ))}
      </div>
      <Copiable texto={ejemplos[pestana]} />
      <div className="muted" style={{ fontSize: 12, marginTop: 8 }}>
        {pestana === 'mcp' ? 'Para Claude, Cursor, VS Code y cualquier cliente MCP por HTTP. Las herramientas llegan como conector__herramienta.' : 'Cualquier SDK o herramienta que hable con OpenAI sirve: se cambia la dirección base y la llave.'}
      </div>
    </div>
  );
}
